export default {
  v3SubmitErrBtnViewOrder: 'Ver Pedido',
  v3SubmitErrBtnBackHome: 'Inicio',
  v3SubmitErrBtnRetry: 'Reintentar',
  v3SubmitErrBtnRelogin: 'Volver a iniciar sesión',
  v3SubmitErrBtnSwitchPay: 'Cambiar método de pago',
  v3SubmitErrBtnReorder: 'Volver a pedir',
  v3SubmitErrBtnSwitchServer: 'Cambiar de servidor',
  v3SubmitErrBtnViewOrderStatus: 'Estado del pedido',
  v3SubmitErrBtnBackStore: 'Volver a la tienda',
  v3SubmitErrBtnGoUpdate: 'Actualizar',
  v3SubmitErrBtnResubscribe: 'Volver a suscribir',
  v3SubmitErrTipUpdateApp: 'Actualiza desde la tienda de aplicaciones',
  v3SubmitErrTipRelogin: 'Por favor, inicia sesión de nuevo',

  v3SubmitErrMsg120009: 'Pedido procesado – revisa tu mochila en el juego.',
  v3SubmitErrMsg120003: 'Error en la información del producto – vuelve a seleccionar.',
  v3SubmitErrMsg120016: 'Demasiadas solicitudes – espera unos segundos y reintenta.',
  v3SubmitErrMsg120025: 'Parámetros de solicitud anómalos – inicia sesión de nuevo y reintenta.',
  v3SubmitErrMsg121012: 'Canal de pago temporalmente no disponible – prueba otro método.',
  v3SubmitErrMsg120012: 'Red inestable – comprueba tu conexión y reintenta.',
  v3SubmitErrMsg120002: 'No se encontró personaje – crea uno primero.',
  v3SubmitErrMsg121019: 'Error en la información del pedido – vuelve a realizar el pedido.',
  v3SubmitErrMsg120024: 'Regalo de preregistro ya reclamado – no repitas.',
  v3SubmitErrMsg120000: 'La sesión ha expirado – inicia sesión de nuevo.',
  v3SubmitErrMsg120014: 'Número de pedido inválido – vuelve a realizar el pedido.',
  v3SubmitErrMsg121001: 'Recarga en el juego falló – reintenta más tarde o contacta soporte.',
  v3SubmitErrMsg120015: 'Importe de pago anómalo – vuelve a seleccionar el producto.',
  v3SubmitErrMsg120001: 'El servidor no coincide – cambia al servidor correcto.',
  v3SubmitErrMsg120020: 'El canal de pago devolvió un error – prueba otro método.',
  v3SubmitErrMsg120010: 'Función de recarga temporalmente desactivada – vuelve a intentarlo más tarde.',
  v3SubmitErrMsg120006: 'Falló la verificación del importe – vuelve a seleccionar.',
  v3SubmitErrMsg121010: 'Solicitud de recarga en sandbox inválida – usa la versión oficial.',
  v3SubmitErrMsg120017: 'Número de pedido duplicado – comprueba si ya está pagado.',
  v3SubmitErrMsg120022: 'Falló la verificación de callback de pago – reintenta más tarde.',
  v3SubmitErrMsg121000: 'Sistema ocupado – reintenta más tarde.',
  v3SubmitErrMsg120011: 'ID de producto incorrecto – vuelve a seleccionar.',
  v3SubmitErrMsg121015: 'Falló la verificación del importe de pago – vuelve a realizar el pedido.',
  v3SubmitErrMsg120004: 'El canal de pago no está abierto – elige otro método.',
  v3SubmitErrMsg120005: 'Canal de pago en mantenimiento – usa otro método.',
  v3SubmitErrMsg120007: 'ID de plataforma inválido – inicia sesión de nuevo.',
  v3SubmitErrMsg120008: 'Parámetros de solicitud insuficientes – vuelve a enviar.',
  v3SubmitErrMsg120013: 'Número de pedido del desarrollador inválido – vuelve a realizar el pedido.',
  v3SubmitErrMsg120018: 'Pago bloqueado por control de riesgos – contacta con soporte para verificar.',
  v3SubmitErrMsg120019: 'Falló la verificación del nombre del paquete – usa la versión oficial.',
  v3SubmitErrMsg120021: 'Falló la verificación del ID del producto – vuelve a seleccionar.',
  v3SubmitErrMsg120023: 'Error en la entrega del regalo de preregistro – consulta más tarde.',
  v3SubmitErrMsg120026: 'Cuenta no encontrada – comprueba el estado de tu cuenta.',
  v3SubmitErrMsg120030: 'Stock total insuficiente – elige otro producto.',
  v3SubmitErrMsg120031: 'Has superado el límite de compra de este artículo – ajusta.',
  v3SubmitErrMsg120032: 'Versión del juego demasiado antigua – descarga la última versión.',
  v3SubmitErrMsg120080: 'Pago por agente limitado por control de riesgos – usa tu propio método de pago.',
  v3SubmitErrMsg120081: 'Pago por agente retrasado por control de riesgos – consulta el resultado más tarde.',
  v3SubmitErrMsg121002: 'Caché de pedido inválido – vuelve a realizar el pedido.',
  v3SubmitErrMsg121003: 'Configuración de recarga no encontrada – contacta con soporte.',
  v3SubmitErrMsg121004: 'Parámetros extendidos insuficientes – vuelve a enviar.',
  v3SubmitErrMsg121005: 'Falló la escritura en caché – reintenta más tarde.',
  v3SubmitErrMsg121006: 'Falló la lectura de caché – reintenta más tarde.',
  v3SubmitErrMsg121007: 'Error de configuración del tipo de recarga – contacta con soporte.',
  v3SubmitErrMsg121011: 'Se detectaron nuevos campos de Apple – actualiza la aplicación.',
  v3SubmitErrMsg121013: 'Pedido de renovación no encontrado – vuelve a suscribirte.',
  v3SubmitErrMsg121014: 'Falló el descifrado de los parámetros de recarga – vuelve a enviar.',
  v3SubmitErrMsg121017: 'Este pedido ha sido reembolsado – contacta con soporte para confirmar.',
  v3SubmitErrMsg121018: 'Suscripción caducada – vuelve a suscribirte.',
  v3SubmitErrMsg121020: 'Pedido cancelado – vuelve a realizar el pedido.',
  v3SubmitErrMsg121021: 'Error de la API de Google – reintenta más tarde.',
  v3SubmitErrMsg121022: 'Falló obtener el token de acceso – inicia sesión de nuevo.',
  v3SubmitErrMsg121023: 'Estado del pedido anómalo – consulta el estado de ingreso.',
  v3SubmitErrMsg121024: 'Falló la confirmación del pedido – reintenta más tarde.'
};
